export { default as translations } from './translations.json';

/**
 * Client-side pattern matching (mirrors server logic).
 * @param {string} query
 * @param {Object[]} faq
 * @returns {{ response: string, matched: boolean } | null}
 */
export const findAnswerClient = (query, faq) => {
  if (!Array.isArray(faq) || !query?.trim()) return null;
  const normalized = query.toLowerCase();
  for (const entry of faq) {
    if ((entry.patterns || []).some(p => normalized.includes(p.toLowerCase()))) {
      return { response: entry.response, matched: true, entryId: entry.id };
    }
  }
  return { response: null, matched: false, entryId: null };
};
